
<template>
  <div class="page">
    <NavBar />
    <van-skeleton title :row="4" :loading="loading">
      <div class="list">
        <MyCard
          v-for="item in cards"
          :key="item.id"
          :card="item"
        />
        <div v-if="!loading && cards.length === 0" class="empty">No gift cards</div>
      </div>
    </van-skeleton>
    <OrderBtn>
      <div class="add-btn" @click="showAdd = true">Add Gift Card</div>
    </OrderBtn>
    <van-popup
      v-model="showAdd"
      round
      closeable
      close-icon-position="top-right"
      :style="{ width: '86%', padding: '1rem', boxSizing: 'border-box' }"
    >
      <div class="popup-title">Add Gift Card</div>
      <van-field v-model="form.number" placeholder="Please enter card number" clearable />
      <div class="popup-btn" @click="handleAdd">Add Card</div>
    </van-popup>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar/index.vue'
import OrderBtn from '@/components/Order/btn.vue'
import MyCard from '@/components/GiftCard/MyCard.vue'
import { Toast } from 'vant'
export default {
  name: 'MyGiftCard',
  components: { NavBar, OrderBtn, MyCard },
  data() {
    return {
      showAdd: false,
      form: { number: '' },
      loading: false,
      cards: [],
      queryForm: {
        page: 1,
        list_rows: 15
      }
    }
  },
  created() {
    this.getGiftCardList()
  },
  methods: {
    async getGiftCardList() {
      this.loading = true
      try {
        const res = await this.$api.getUserGiftCardList({ ...this.queryForm })
        if (res.code === 1 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : []
          this.cards = list.map((item, index) => this.formatCard(item, index))
        } else {
          this.cards = []
        }
      } catch (error) {
        this.cards = []
      } finally {
        this.loading = false
      }
    },
    formatCard(item, index) {
      const instance = item.giftCardInstance || {}
      const giftCard = instance.giftCard || {}
      const supplier = giftCard.supplier || {}
      const cardImageRaw = giftCard.card_image || ''
      // 提前转换图片路径为完整 URL
      const cardImage = this.formatImagePath(cardImageRaw)
      return {
        id: item.id || instance.id || `card-${index}`,
        detailId: giftCard.id || item.id,
        number: instance.card_no || '',
        storeName: supplier.name || giftCard.name || item.alias || 'Gift Card',
        address: supplier.address || '',
        amount: instance.balance || instance.initial_value || 0,
        card_image: cardImage || '', // 使用转换后的完整 URL
        bg: this.randomBg()
      }
    },
    formatImagePath(path) {
      if (!path) return ''
      let finalPath = path.trim()
      if (/^https?:/i.test(finalPath)) {
        return finalPath.replace('http://localhost:8080', 'http://www.hwm.red')
      }
      finalPath = finalPath.replace(/^\/+/, '')
      // 相对路径需要加上 /uploads/ 前缀（参考网页端的 resolveUploadUrl）
      const fullPath = finalPath.startsWith('uploads/') ? `/${finalPath}` : `/uploads/${finalPath}`
      return `http://www.hwm.red${fullPath}`
    },
    randomBg() {
      // 1~3 随机一个背景图
      return Math.floor(Math.random() * 3) + 1
    },
    async handleAdd() {
      const n = (this.form.number || '').replace(/\s+/g, '')
      if (!n) {
        Toast && Toast('Please enter card number')
        return
      }
      try {
        const res = await this.$api.bindGiftCard({ card_no: n })
        const msg = (res && res.msg) || 'Done'
        Toast && Toast(msg)
        if (res && res.code === 1) {
          this.form.number = ''
          this.showAdd = false
          // 绑定成功后刷新礼品卡列表
          this.getGiftCardList()
        }
      } catch (error) {
        Toast && Toast('Bind failed. Please try again later.')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}
.add-btn {
  width: 100%;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  background: #1e3c3e;
  color: #fff;
}
.popup-title {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #333;
}
.popup-btn {
  width: 100%;
  height: 2.5rem;
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  background: #1e3c3e;
  color: #fff;
}
.empty {
  text-align: center;
  color: #999;
  padding: 2rem 0;
}
</style>
